import service from './request'
import uploadService from "./uploadRequest.js";
import downloadService from "./downloadRequest.js";

/**
 * 获取客户标签信息列表
 */
export const getListCusLable = data => {
    return service({
	      showLoading: true,//调用预加载
        url: '/crm/cusLable/cfg/getList',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 获取客户标签信息树
 */
 export const getTreeCusLable = data => {
    return service({
        showLoading: true,//调用预加载
        url: '/crm/cusLable/cfg/getTree',
        method: 'post',
        type: 'body',
        data
    })
}


/**
 * 获取客户标签信息树
 */
export const getTreeInfoCusLable = data => {
    return service({
        showLoading: true,//调用预加载
        url: '/crm/cusLable/cfg/getTreeInfo',
        method: 'post',
        type: 'body',
        data
    })
}

/**
 * 客户标签信息添加
 */
export const addInfoCusLable = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/crm/cusLable/cfg/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 客户标签信息修改
 */
 export const updateInfoCusLable = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/crm/cusLable/cfg/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 客户标签删除
 */
 export const delInfoCusLable = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/crm/cusLable/cfg/delInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 客户标签导出
 */
 export const expExcelCusLable = data => {
    return downloadService({
        showLoading: true,
        url: "/crm/cusLable/cfg/expExcel",
        method: "get",
        responseType: "blob",
        data
    });
}


/**
 * 客户标签导入
 */
export const impExcelCusLable = data => {
    return uploadService({
        showLoading: true,
        url: "/crm/cusLable/cfg/impExcel",
        method: "post",
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/cusLableManagement.js